<template lang="pug">
VContainer.qmodii-cont.qmodii-advanced-chart(fluid, grid-list-md)
  BaseWrapper.qmodii-component-wrap.qmodii-component-advancedChart
    VDialog(v-model="dialog", v-if="getModalIsOpen", max-width="600px")
      component(
        :is="getCurrentModal",
        :chartype="options.list[4].dropdown.selected",
        :list="indicators",
        :lowerlist="lowerindicators",
        :activelist="ActiveIndicators",
        @addInd="addIndp",
        @delInd="removeIndp",
        :token="authTOken",
        :mutex="mutex",
        @addSymbolLookup="addSymbolLookup",
        :customIndcies="PropIndcies",
      )
    VLayout(align-center, row)
      VFlex(xs12)
        .qmodii-component-cont
          .qmodii-component-header.qmodii-modifiers
            VContainer.qmodii-cont.qmodii-adv-chart-cont(fluid, grid-list-md)
              VLayout(align-start, justify-start, row, wrap)
                VFlex(xs12, sm6, md6, lg3, v-if="PropDatescaleEnabled")
                  VTabs(
                    v-model="scales.selected",
                    color="primary",
                    dark,
                    :max="350",
                    :grow="true",
                    :show-arrows="true"
                  )
                    VTab(
                      v-for="(scale, idx) in scales.list",
                      :key="idx",
                      ripple,
                      @click="changeScale(scale.value, idx)",
                      @keydown="changeScale(scale.value, idx)",
                      href="#"
                    ) {{ $t(scale.label) }}
                VFlex(xs12, sm6, md6, lg2, v-if="PropTimescaleEnabled")
                  VSelect.sstest(
                    :items="frequency.dropdown.list",
                    @input="changeFrequency()",
                    v-model="frequency.dropdown.selected",
                    attach,
                    v-bind:label="$t('labels.frequency')",
                    dense,
                    :menu-props="{ }"
                  )
                    template(slot='selection' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                    template(slot='item' slot-scope="{ item }")
                        | {{ $t(item.text) }}
                  VSpacer
                VFlex(xs12, sm12, md12, lg7, align-start)
                  VLayout(
                    align-center,
                    justify-end,
                    align-content-start,
                    row,
                    wrap
                  )
                    VSpacer
                    VFlex(xs12, sm3, lg3, v-if="PropEventsEnabled")
                      VSelect(
                        :items="events",
                        @input="triggerEvent()",
                        v-model="eventsEnabled",
                        v-bind:label="$t('labels.events')",
                        attach,
                        multiple,
                        dense,
                        :menu-props="{ }"
                      )
                        template(
                          slot="selection",
                          slot-scope="{ item, index }"
                        )
                          span.qmod-chips.primary {{ item.short }}
                        template(slot='item' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                    VFlex(xs12, sm3, lg3, v-if="PropAdjustmentsEnabled")
                      VSelect(
                        :items="options.list[2].dropdown.list",
                        @input="options.list[2].dropdown.onClick()",
                        attach,
                        v-model="options.list[2].dropdown.selected",
                        :label="$t(options.list[2].label)",
                        dense,
                        :menu-props="{ allowOverflow: true }"
                      )
                        template(slot='selection' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                        template(slot='item' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                    VFlex(xs12, sm3, lg3, v-if="PropScaleEnabled")
                      VSelect(
                        :items="options.list[3].dropdown.list",
                        :disabled="options.list[3].dropdown.disabled",
                        attach,
                        @input="options.list[3].dropdown.onClick()",
                        v-model="options.list[3].dropdown.selected",
                        :label="$t(options.list[3].label)",
                        dense,
                        :menu-props="{  }"
                      )
                        template(slot='selection' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                        template(slot='item' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                    VFlex(xs12, sm3, lg3, v-if="PropChartTypeEnabled")
                      VSelect(
                        :items="options.list[4].dropdown.list",
                        @input="options.list[4].dropdown.onClick()",
                        attach,
                        v-model="options.list[4].dropdown.selected",
                        :label="$t(options.list[4].label)",
                        dense,
                        :menu-props="{ }"
                      )
                        template(slot='selection' slot-scope="{ item }")
                          | {{ $t(item.text) }}
                        template(slot='item' slot-scope="{ item }")
                          | {{ $t(item.text) }}
          .qmodii-component-header.qmodii-component-symbolbar
            .qmodii-advChart-series
              span.qmodii-advChart-series-item(
                v-for="(symbol, idx) in getsymbolList"
              )
                span.qmodii-symbol(
                  @click="openSymbolLook()",
                  v-bind:style="{ borderColor: symbol.color }"
                ) {{ symbol.label }}
                span.qmodii-close(
                  v-if="PropRemovableSymbolCount <= idx",
                  @click="removeSymbol(symbol, idx)"
                ) &times;
            .qmodii-advChart-addCompare
              VBtn(
                color="primary",
                @click="openSymbolLook('compare')",
                v-if="PropAddSymbolEnabled"
              ) {{ $t('buttons.add_symbol') }}
              VBtn(
                color="secondary",
                @click="showModal2({ label: 'Indicators' })",
                v-if="PropIndicatorsEnabled"
              ) {{ $t('buttons.indicators') }}
            .qmodii-advChart-savesettings(v-if="PropSavingEnabled")
              VSpacer
              VBtn(
                color="primary",
                @click="saveSettings()",
                v-if="PropAddSymbolEnabled"
              ) {{ $t('buttons.save') }}
              VBtn(
                color="red",
                @click="resetSettings()",
                v-if="PropAddSymbolEnabled"
              )  {{ $t('buttons.reset') }}
              //- span.qmodii-advChart-series-item(@click="openSymbolLook('compare')") Add Symbol
          .qmodii-component-body
            .qmodii-advChart-cont
              .qmodii-advChart-chart
</template>

<script>
import {
  VContainer,
  VLayout,
  VFlex,
  VBtn,
  VSelect,
  VTabs,
  VTab,
  VSpacer,
  VDialog,
  VBtnToggle
} from "vuetify/lib";
import { mapGetters, mapState } from "vuex";
import state from "./state";
import axios from "axios";
import BaseWrapper from "@LAYOUT/BaseWrapper";
import BaseDropdown from "@LAYOUT/BaseDropdown";
import ModalWrapper from "./modals/ModalWrapper";
import Events from "./modals/Events";
import Indicators from "./modals/Indicators";
import SymbolLookup from "./modals/SymbolLookup";

import HCDP from "highcharts/modules/drag-panes";

//Upper indicators (Ichimoku Kinko Hyo, Pivot Points, Price Envelopes, PSAR, VbP, Zig Zag)

import HCID from "highcharts/indicators/indicators";

import HCPP from "highcharts/indicators/pivot-points";
import HCPE from "highcharts/indicators/price-envelopes";
import HCPSAR from "highcharts/indicators/psar";
import HCVBP from "highcharts/indicators/volume-by-price";
import HCZZ from "highcharts/indicators/zigzag";

import HCTEMA from "highcharts/indicators/tema";
import HCEMA from "highcharts/indicators/ema";
import HCBB from "highcharts/indicators/bollinger-bands";
import HCMACD from "highcharts/indicators/macd";

import HCRSI from "highcharts/indicators/rsi";
import HCVWAP from "highcharts/indicators/vwap.src";

import ATR from "highcharts/indicators/atr";
import CCI from "highcharts/indicators/cci";
import MOMENTUM from "highcharts/indicators/momentum";
import ROC from "highcharts/indicators/roc";
import WMA from "highcharts/indicators/wma";

import HCDPO from "highcharts/indicators/dpo";
import HCTRIX from "highcharts/indicators/trix";

import WILR from "highcharts/indicators/williams-r";

import exporting from 'highcharts/modules/exporting';
import offlineexport from 'highcharts/modules/offline-exporting';

// import { buildDataUrl } from "@/utils"

export default {
  components: {
    VContainer,
    BaseWrapper,
    ModalWrapper,
    BaseDropdown,
    Events,
    Indicators,
    SymbolLookup,
    VBtn,
    VSelect,
    VTabs,
    VTab,
    VLayout,
    VFlex,
    VSpacer,
    VDialog,
    VBtnToggle,
  },
  name: "AdvancedChart",
  props: {
    qmLanguage: {
      type: String,
      default: "en",
    },
    qmWMID: {
      type: Number,
    },
    PropSymbols: {
      type: String,
      default: "GOOGL",
    },
    PropSeriesColors: {
      type: Array,
      default: () => [
        "#0a64a6",
        "#bec439",
        "#8bbc21",
        "#910000",
        "#1aadce",
        "#492970",
        "#f28f43",
        "#77a1e5",
        "#c42525",
        "#a6c96a",
      ],
    },
    PropChartType: {
      type: String,
      default: "line",
    },
    PropDatescaleEnabled: {
      type: Boolean,
      default: true,
    },
    PropTimescaleEnabled: {
      type: Boolean,
      default: true,
    },
    PropEventsEnabled: {
      type: Boolean,
      default: true,
    },
    PropIndicatorsEnabled: {
      type: Boolean,
      default: true,
    },
    PropAdjustmentsEnabled: {
      type: Boolean,
      default: true,
    },
    PropScaleEnabled: {
      type: Boolean,
      default: true,
    },
    PropChartTypeEnabled: {
      type: Boolean,
      default: true,
    },
    PropAddSymbolEnabled: {
      type: Boolean,
      default: true,
    },
    PropHCNavigatorEnabled: {
      type: Boolean,
      default: true,
    },
    PropRemovableSymbolCount: {
      type: Number,
      default: 1,
    },
    PropEnable20Year: {
      type: Boolean,
      default: false,
    },
    PropEnable30Year: {
        type: Boolean,
        default: false,
    },
    PropSavingEnabled: {
      type: Boolean,
      default: false,
    },
    PropTimeFrame: {
      type: String,
      default: "3M",
    },
    PropEnabledEvents: {
      type: String,
      default: "",
    },
    PropCopyright: {
        type: Boolean,
        default: true,
    },
    PropAdjustmentType: {
        type: String,
        default: 'none',
    },
    PropScale: {
        type: String,
        default: 'none',
    },
    PropIndcies: {
        type: Array,
        default: () => [{
          label: 'Dow Jones Industrial Average',
          symbol: '^DJI'
        },
        {
          label: 'S&P 500',
          symbol: '^IN'
        },
        {
          label: 'NASDAQ Composite',
          symbol: '^COMPX'
        },
        {
          label: 'S&P/TSX Composite Index',
          symbol: '^TSX:CA'
        },
        {
          label: 'S&P/TSX Venture Composite Index',
          symbol: '^JX:CA'
        }
      ],
    },
  },
  async created() {
      this.mutex = Math.floor(Math.random() * 1000000000);

    // let url = buildDataUrl("sdsdsdds", { a: "b" })
    this.$store.registerModule(`AdvancedChart_${this.mutex}`, state);
    this.$store.commit(`AdvancedChart_${this.mutex}/SET_CHART_COLORS`, this.PropSeriesColors);
    window.addEventListener("QMOD:TOOL:ADVANCEDCHART", async (event) => {
      // console.log(event);
      if (event.detail.type == "CHANGE_SYMBOL") {
        this.removeAllSymbols();
        await this.addSymbolLookup(event.detail.payload);
      }
    });
  },

  data() {
    return {
        chart: null,
        mutex: null,
      ogProps: {},
      dialog: true,
      authTOken: null,
      msg: "advancedChart ",
      scales: {
        selected: 2,
        list: [
          { label: "labels.1D", value: "1D", type: "int" },
          { label: "labels.5D", value: "5D", type: "int" },
          { label: "labels.3M", value: "3M", type: "eod" },
          { label: "labels.6M", value: "6M", type: "eod" },
          { label: "labels.YTD", value: "YTD", type: "eod" },
          { label: "labels.1Y", value: "1Y", type: "eod" },
          { label: "labels.2Y", value: "2Y", type: "eod" },
          { label: "labels.3Y", value: "3Y", type: "eod" },
          { label: "labels.5Y", value: "5Y", type: "eod" },
          { label: "labels.10Y", value: "10Y", type: "eod" },
        ],
      },
      freqs: {
        label: "Frequency",
        int: {
          dropdown: {
            open: false,
            selected: "1",
            list: [
              { text: "labels.1min", value: "1" },
              { text: "labels.2min", value: "2" },
              { text: "labels.5min", value: "5" },
              { text: "labels.10min", value: "10" },
              { text: "labels.15min", value: "15" },
              { text: "labels.60min", value: "60" },
            ],
          },
        },
        eod: {
          dropdown: {
            open: false,
            selected: "day",
            list: [
              { text: "labels.daily", value: "day" },
              { text: "labels.weekly", value: "week" },
              { text: "labels.monthly", value: "month" },
            ],
          },
        },
      },
      options: {
        name: "Settings",
        list: [
          { label: "Events" },
          { label: "Indicators", onClick: "" },
          {
            label: "labels.adjustments",
            onClick: "",
            dropdown: {
              open: false,
              selected: this.PropAdjustmentType,
              onClick: this.changeAdjustment,
              list: [
                { text: "labels.splits_and_divs", value: "none" },
                { text: "labels.splits", value: "so" },
                { text: "labels.unadjusted", value: "unadjusted" },
              ],
            },
          },
          {
            label: "labels.scale",
            onClick: "",
            dropdown: {
              disabled: false,
              open: false,
              selected: this.PropScale,
              onClick: this.changeAxisScale,
              list: [
                { text: "labels.price", value: "" },
                { text: "labels.change_dollar", value: "value" },
                { text: "labels.change_percent", value: "percent" },
              ],
            },
          },
          {
            label: "labels.type",
            onClick: "",
            dropdown: {
              open: false,
              selected: this.PropChartType,
              onClick: this.changeChartType,
              list: [
                {
                  text: "labels.area",
                  value: "area",
                  disabled: false,
                },
                { text: "labels.line", value: "line" },
                { text: "labels.OHLC+", value: "ohlcc" },
                { text: "labels.OHLC", value: "ohlc" },
                { text: "labels.Candlestick+", value: "ccandlestick" },
                { text: "labels.Candlestick", value: "candlestick" },
              ],
            },
          },
        ],
      },
      chartCallParams: {
        zeroTradeDays: false,
        start: "2017-11-01",
        interval: 1,
        marketSession: "mkt",
        freq: "day",
        adjusted: true,
        adjustmentType: "none",
        unadjusted: false,
        datatype: "eod",
      },
      lowerindicators: [
        {
          desc: this.$t("labels.moving_average_convergence_divergence"),
          event: "MACD",
          name: this.$t("labels.MACD"),
          isEnabled: false,
          params: {
            index: 3,
            period: 26,
            longPeriod: 26,
            shortPeriod: 12,
            signalPeriod: 9,
          },
          isLower: true,
          needsVolume: true,
        },
        {
          event: "RSI",
          name: this.$t("labels.RSI"),
          desc: this.$t("labels.relative_strength_index"),
          isEnabled: false,
          params: { period: 14 },
          isLower: true,
          needsOHLC: true,
        },
        {
          event: "ATR",
          name: this.$t("labels.ATR"),
          desc: this.$t("labels.average_true_range"),
          isEnabled: false,
          params: { index: 3, period: 14 },
          isLower: true,
          needsOHLC: true,
        },
        {
          event: "ROC",
          name: this.$t("labels.ROC"),
          desc: this.$t("labels.rate_of_change"),
          isEnabled: false,
          params: { index: 3, period: 9 },
          isLower: true,
        },
        {
          event: "CCI",
          name: this.$t("labels.CCI"),
          desc: this.$t("labels.commodity_channel_index"),
          isEnabled: false,
          params: { index: 3, period: 14 },
          isLower: true,
          needsOHLC: true,
        },
        {
          event: "Momentum",
          name: this.$t("labels.momentum"),
          desc: this.$t("labels.momentum"),
          isEnabled: false,
          params: { index: 3, period: 14 },
          isLower: true,
          needsOHLC: true,
        },
        {
          event: "DPO",
          name: this.$t("labels.DPO"),
          desc: this.$t("labels.detrended_price"),
          isEnabled: false,
          params: { index: 3, period: 21 },
          isLower: true,
        },
        {
          event: "TRIX",
          name: this.$t("labels.TRIX"),
          desc: this.$t("labels.triple-exponential-average"),
          isEnabled: false,
          params: { index: 3, period: 9 },
          isLower: true,
        },
        {
          event: "WilliamsR",
          name: this.$t("labels.WilliamsR"),
          desc: this.$t('labels.williams-r'),
          isEnabled: false,
          params: { index: 3, period: 14 },
          isLower: true,
          needsOHLC: true,
        },
      ],

      indicators: [
        {
          event: 'EMA', 
          name: this.$t("labels.ema"),
          desc: this.$t("labels.exponential_moving_average"),
          isEnabled: false,
          params: { index: 3, period: 9 },
        },
        {
          event: 'VWAP',
          name: this.$t("labels.vwap"),
          desc: this.$t("labels.volume_weighted_average_price"),
          isEnabled: false,
          params: { period: 30 },
          needsVolume: true,
        },
        {
          event: 'SMA',
          name: this.$t("labels.sma"),
          desc: this.$t("labels.simple_moving_average"),
          isEnabled: false,
          params: { index: 3, period: 14 },
        },

        {
          event: "TEMA",
          name: this.$t("labels.TEMA"),
          desc: this.$t('labels.triple-ema'),
          isEnabled: false,
          params: { index: 3, period: 9 },
        },

        {
          event: "BB",
          name: this.$t("labels.BB"),
          desc: this.$t("labels.bollinger_bands"),
          isEnabled: false,
          params: { index: 3, period: 20, standardDeviation: 2 },
        },

        {
          event: "WMA",
          name: this.$t("labels.WMA"),
          desc: this.$t("labels.weighted_moving_average"),
          isEnabled: false,
          params: { index: 3, period: 9 },
          needsVolume: true,
        },
        {
          event: "PivotPoints",
          name: this.$t("labels.PivotPoints"),
          desc: this.$t("labels.pivotpoints"),
          isEnabled: false,
          params: { period: 28 },
          needsOHLC: true,
        },

        {
          event: "PriceEnvelopes",
          name: this.$t("labels.PriceEnvelopes"),
          desc: this.$t("labels.priceenvelopes"),
          isEnabled: false,
          params: { index: 3, period: 20, bottomBand: 0.1, topBand: 0.1 },
          needsOHLC: true,
        },

        {
          event: "PSAR",
          name: this.$t("labels.PSAR"),
          desc: this.$t("labels.parabolic_sar"),
          isEnabled: false,
          params: {
            index: 3,
            increment: 0.02,
            initialAccelerationFactor: 0.02,
            maxAccelerationFactor: 0.2,
          },
          needsOHLC: true,
        },

        {
          event: "VBP",
          name: this.$t("labels.VBP"),
          desc: this.$t("labels.volume_by_price"),
          isEnabled: false,
          params: { ranges: 12 },
          needsVolume: true,
        },

        {
          event: "Zigzag",
          name: this.$t("labels.Zigzag"),
          desc: this.$t("labels.zigzag"),
          isEnabled: false,
          params: { deviation: 1, highIndex: 1, lowIndex: 2 },
          needsVolume: true,
          needsOHLC: true,
        },
      ],
      ActiveIndicators: [],
      eventsEnabled: [],
      events: [
        { text: this.$t("labels.earnings"), value: "earnings", short: "E" },
        { text: this.$t("labels.splits"), value: "splits", short: "S" },
        { text: this.$t("labels.dividends"), value: "dividends", short: "D" },
      ],
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
        return false;
      }
    },
  },
  methods: {
    saveSettings() {
      let settings = {};
      settings["scales"] = this.scales.selected;
      settings["freqs_int"] = this.freqs.int.dropdown.selected;
      settings["freqs_eod"] = this.freqs.eod.dropdown.selected;
      settings["adjusments"] = this.options.list[2].dropdown.selected;
      settings["scale"] = this.options.list[3].dropdown.selected;
      settings["type"] = this.options.list[4].dropdown.selected;
      settings["datatype"] = this.chartCallParams.datatype;

      settings["eventsEnabled"] = this.eventsEnabled;

      // settings["symbolist"] = JSON.parse(JSON.stringify(this.getsymbolList));

      window.localStorage.setItem("qmod_adv_chart", JSON.stringify(settings));
    },
    resetSettings() {
      window.localStorage.removeItem("qmod_adv_chart");

      this.PropChartType = this.ogProps["PropChartType"];

      this.scales.selected = this.ogProps["scalesSelected"];
      this.options.list[4].dropdown.selected = this.ogProps["PropChartType"];
      this.options.list[3].dropdown.selected = this.ogProps["propPriceScale"];
      this.options.list[2].dropdown.selected = this.ogProps["propAdjustments"];
      this.chartCallParams.datatype = this.ogProps["propDatatype"];

      this.freqs.eod.dropdown.selected = this.ogProps["freqEod"];
      this.freqs.int.dropdown.selected = this.ogProps["freqInt"];

      this.modifyAdjustment();
      this.modifyFrequency();

      // this.PropSymbols = this.ogProps["PropSymbols"];
      this.eventsEnabled = this.ogProps["PropEvents"];

      this.removeAllSymbols();

      this.PropSymbols.split(",").forEach((element) => {
        this.addSymbolLookup(element);
      });
    },
    closemodals() {
      this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
    },
    modifyAdjustment() {
      if (this.options.list[2].dropdown.selected == "none") {
        this.chartCallParams.adjusted = true;
        this.chartCallParams.unadjusted = false;
        this.chartCallParams.adjustmentType = this.options.list[2].dropdown.selected;
      } else if (this.options.list[2].dropdown.selected == "so") {
        this.chartCallParams.adjusted = true;
        this.chartCallParams.unadjusted = false;
        this.chartCallParams.adjustmentType = this.options.list[2].dropdown.selected;
      } else if (this.options.list[2].dropdown.selected == "unadjusted") {
        this.chartCallParams.adjusted = false;
        this.chartCallParams.unadjusted = true;
        this.chartCallParams.adjustmentType = "none";
      }
    },
    changeAdjustment() {
      this.modifyAdjustment();

      this.reloadChart();
      return;
    },
    changeAxisScale() {
      let chartType = this.options.list[4].dropdown.selected;
      if (chartType=='area') return;
      this.$store.state[`AdvancedChart_${this.mutex}`].chart.yAxis[0].setCompare(
        this.options.list[3].dropdown.selected,
        false
      );

      this.$store.state[`AdvancedChart_${this.mutex}`].chart.redraw();
      return;
    },
    modifyFrequency() {
      if (this.chartCallParams.datatype == "int") {
        this.chartCallParams.interval = this.frequency.dropdown.selected;
      } else {

        this.chartCallParams.freq = this.frequency.dropdown.selected;
      }
    },
    changeFrequency() {
      this.modifyFrequency();

      this.reloadChart();
    },
    changeChartType(selectObj) {
      this.$nextTick(() => {
        let chartType = this.options.list[4].dropdown.selected;
        var ops = {};

        this.getsymbolList.forEach((element) => {
          let s = this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(element.symbolstring);
          if (chartType == "ccandlestick") {
            ops = {
              type: "candlestick",
              color: "#F44336",
              upColor: s.userOptions.ogColor //upColor: "#4CAF50",
            };
          } else if (chartType == "ohlcc") {
            ops = {
              type: "ohlc",
              color: "#F44336",
              upColor: s.userOptions.ogColor //upColor: "#4CAF50",
            };
          } else {
            ops = {
              color: s.userOptions.ogColor,
              type: chartType,
              upColor: chartType == "ohlc" ? s.ogColor : "#fff",
            };
          }
          s.update(ops, false);
        });

        if (chartType == "area") {
          this.options.list[3].dropdown.selected = "";
          this.$store.state[`AdvancedChart_${this.mutex}`].chart.yAxis[0].setCompare(
            this.options.list[3].dropdown.selected,
            false
          );

          this.options.list[3].dropdown.disabled = true;

          this.$store.state[`AdvancedChart_${this.mutex}`].chart.yAxis[0].update(
            {
              type: "logarithmic",
            },
            false
          );
        } else {
          this.options.list[3].dropdown.disabled = false;
          this.$store.state[`AdvancedChart_${this.mutex}`].chart.yAxis[0].update(
            {
              type: "linear",
            },
            false
          );
        }

        this.refreshAllSeries(1);
        this.$store.state[`AdvancedChart_${this.mutex}`].chart.redraw();
      });
    },
    async addSymbolLookup(symbol) {
        let exists = false;
      symbol = symbol.toUpperCase();

        this.getsymbolList.filter(item => {
            if (item.symbolstring === symbol) {
                exists = true;
            }
        })

        if (exists) return;

      await this.addCompare(symbol);
    },
    async addCompare(symbol) {
      // if (this.getsymbolList.length == 1) {
      //   this.options.list[4].dropdown.list[0].disabled = true;
      //   if (this.options.list[4].dropdown.selected == "area") {
      //     this.options.list[4].dropdown.selected = "line";
      //     this.changeChartType();
      //   }
      // }
      this.$store.commit(`AdvancedChart_${this.mutex}/ADD_SYMBOL_LIST`, {
        symbolstring: symbol,
      });

      // if (this.getsymbolList.length > 1) {
      //   this.options.list[3].dropdown.selected = "percent";
      // }

      await this.reloadChart();
        this.changeAxisScale();
    },
    removeAllSymbols() {
      for (let index = this.getsymbolList.length - 1; index >= 0; index--) {
        const element = this.getsymbolList[index];
        this.$store.commit(`AdvancedChart_${this.mutex}/DEL_SYMBOL_LIST`, index);
        this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(element.symbolstring).remove();
        this.$store.state[`AdvancedChart_${this.mutex}`].chart.get("vol_" + element.symbolstring).remove();
      }

      if (this.getsymbolList.length <= 1) {
        this.options.list[4].dropdown.list[0].disabled = false;
        this.options.list[3].dropdown.selected = "";
      }

      this.changeAxisScale();
      this.reloadChart();
    },

    removeSymbol(symbol, index) {
      this.$store.commit(`AdvancedChart_${this.mutex}/DEL_SYMBOL_LIST`, index);
      // this.series.splice(index, 1)

      this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(symbol.symbolstring).remove();
      this.$store.state[`AdvancedChart_${this.mutex}`].chart.get("vol_" + symbol.symbolstring).remove();

      if (this.getsymbolList.length <= 1) {
        this.options.list[4].dropdown.list[0].disabled = false;
        this.options.list[3].dropdown.selected = "";
      }

      this.changeAxisScale();
      this.reloadChart();
    },
    async triggerEvent() {
      this.events.forEach((event) => {
        let eventExists = this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(event.text.toLowerCase());
        if (eventExists) {
          eventExists.hide();
        }
      });

      this.eventsEnabled.forEach(async (event) => {
        await this.toggleEvent(event);
      });
    },
    async toggleEvent(event) {
        // console.log(event);
      let eventType = event.toLowerCase();
      let eventEnabled = true;
      let title, Events;

      let eventExists = this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(eventType);

      if (eventExists) {
        if (eventEnabled) {
          eventExists.show();
        } else {
          eventExists.hide();
        }
      } else {
        if (eventEnabled) {
          let eventURL = this.genIndicatorURL(
            this.getsymbolList[0].label,
            eventType
          );
          let d = await this.getEventData(eventURL);

          let divTypes = {
            D: "Cash Dividend",
            I: "Interest income",
            S: "Dividend",
            SG: "Short term capital gain",
            MG: "Medium term capital gain",
            LG: "Long term capital gain",
            UG: "Unspecified term capital gain",
          };

          let frequency = {
            A: "Annual",
            M: "Monthly",
            Q: "Quarterly",
            S: "Semi-Annual",
            U: "Unspecified",
            I: "Irregular",
            R: "Other Regular",
          };

          if (eventType === "earnings" && d.results.earnings[0].earning) {
            title = "E";
            Events = d.results.earnings[0].earning
              .map((obj) => {
                return {
                  x: new Date(obj.reportDate[0] + "T13:00:00").getTime(),
                  text: `<table class="qmod-hc-tooltip-table">
                  <tr>
                    <td># Estimates</td>
                    <td>${obj.numOfEstimates}</td>
                  </tr>
                  <tr>
                    <td>Actual Eps</td>
                    <td>${obj.actualEps}</td>
                  </tr>
                  <tr>
                    <td>Announce Time</td>
                    <td>${obj.announceTime}</td>
                  </tr>
                  <tr>
                    <td>Consensus Eps</td>
                    <td>${obj.consensusEps}</td>
                  </tr>
                  <tr>
                    <td>EPS Surprise $</td>
                    <td>${obj.epsSurpriseDollar}</td>
                  </tr>
                  <tr>
                    <td>EPS Surprise %</td>
                    <td>${obj.epsSurprisePercent}</td>
                  </tr>
                  <tr>
                    <td>Estimated EPS</td>
                    <td>${obj.estimatedEps}</td>
                  </tr>
                  <tr>
                    <td>Period</td>
                    <td>${obj.period}</td>
                  </tr>
                  <tr>
                    <td>Quarter End</td>
                    <td>${obj.quarterEnd}</td>
                  </tr>
                </table>`,
                };
              })
              .reverse();
          } else if (eventType == "dividends" && d.results.dividends[0].dividend) {
            title = "D";
            Events = d.results.dividends[0].dividend
              .map((obj) => {
                return {
                  x: new Date(obj.date + "T13:00:00").getTime(),
                  text: `<table class="qmod-hc-tooltip-table">
                  <tr>
                    <td><b>${
                      frequency[obj.frequency]
                    }</b> dividend event, payable <b>${obj.payable}</b>.</td>
                  </tr>
                  <tr>
                    <td><b>${divTypes[obj.divtype]}</b> of <b>${
                    (obj.indicatedrate ? this.formatNumberComma(obj.indicatedrate) : this.formatNumberComma(obj.amount))
                  }</b> in <b>${obj.currency}</b></td>
                  </tr>
                </table>`,
                };
              })
              .reverse();
          } else if (eventType == "splits" && d.results.splits[0].split) {
            title = "S";
            Events = d.results.splits[0].split
              .map((obj) => {
                return {
                  x: new Date(obj.date + "T13:00:00").getTime(),
                  text: `<table class="qmod-hc-tooltip-table">
                  <tr>
                    <td>Stock Split <b>${obj.tofactor}</b>:<b>${obj.forfactor}</b> (Split Ratio <b>${obj.splitratio}</b>)</td>
                  </tr>
                </table>`,
                };
              })
              .reverse();
          }

          let eventSeries = {
            title: title,
            yAxis: 0,
            // xAxis: 0,
            onSeries: this.getsymbolList[0].label,
            type: "flags",
            shape: "circlepin",
            id: eventType,
            visible: true,
            name: eventType,
            flagType: eventType,
            // color: model.scope.binders.chartEvents.list[model.index].color,
            data: Events,
            width: 10,
            zIndex: 99,
            y: 10,
          };

            this.$store.state[`AdvancedChart_${this.mutex}`].chart.addSeries(eventSeries, true);
        }
      }
    },
    async getEventData(eventURL) {
      let cData;

      try {
        const response = await axios.get(eventURL, {
            headers: {
                'Datatool-Token': this.authTOken,
            }
        }
        );
        cData = response.data;
      } catch (e) {
        throw e;
      }

      return cData;
    },
    formatNumberComma(value2) {
      let locale = this.$i18n.locale == "fr" ? "fr-CA" : undefined;
      if (!value2) return "-";
      return Number(value2).toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    },
    getLastYAxis() {
      function isNavigatorAxis(axis) {
        return axis.userOptions.className === "highcharts-navigator-yaxis";
      }
      function getLastAxis(chart) {
        var axes = chart.yAxis,
          len = axes.length - 1;

        // If last yAxis is from navigator, return the previous one:
        return isNavigatorAxis(axes[len]) ? axes[len - 1] : axes[len];
      }
      return getLastAxis(this.$store.state[`AdvancedChart_${this.mutex}`].chart);
    },
    removeIndp(indi) {
      let name = indi.event;
      let indicatorSeries = this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(name);

      if (indi.isLower) {
        this.$store.state[`AdvancedChart_${this.mutex}`].chart.get(`a-${name.toLowerCase()}`).remove(false);
        let allAxis = this.$store.state[`AdvancedChart_${this.mutex}`].chart.yAxis.filter((axes) => {
          return axes.userOptions.className != "highcharts-navigator-yaxis";
        });

        let percent = 10 * allAxis.length;
        percent = 100 - percent.toFixed(2);

        allAxis.forEach((current, currentIdx) => {
          if (currentIdx == 0) {
            current.update(
              {
                top: `0%`,
                height: `${percent + 10}%`,
              },
              false
            );
          } else {
            current.update(
              {
                top: `${percent + currentIdx * 10}%`,
                height: `10%`,
              },
              false
            );
          }
        });
      } else {
        indicatorSeries.remove(false);
      }
      if (
        this.ActiveIndicators.findIndex((e) => e.keyID === indi.keyID) !== -1
      ) {
        let inditoremove = this.ActiveIndicators.findIndex(
          (e) => e.keyID === indi.keyID
        );
        this.ActiveIndicators.splice(inditoremove, 1);
      }
      this.$store.state[`AdvancedChart_${this.mutex}`].chart.redraw(true);
      indi.isEnabled = false;
    },
    addIndp(indi) {
      let name = indi.event.toLowerCase();
      let LastYAxis = this.getLastYAxis();
      indi.keyID = Math.floor(1000 + Math.random() * 9000);

      if (indi.isLower) {
        LastYAxis.update(
          {
            resize: {
              lineColor: "#666666",
              enabled: true,
              controlledAxis: {
                next: [`a-${name}`], //macd
              },
            },
          },
          false
        );

        this.$store.state[`AdvancedChart_${this.mutex}`].chart.addAxis(
          {
            resize: {
              enabled: false,
            },
            offset: 0,
            opposite: true,
            id: `a-${name}`,
            className: `qm-${name}`,
            title: {
              useHTML: true,
              text: `${name}`,
              align: "high",
              rotation: 0,
              reserveSpace: false,
              y: 15,
            },
            labels: {
              align: "right",
            },
          },
          false
        );

        let allAxis = this.$store.state[`AdvancedChart_${this.mutex}`].chart.yAxis.filter((axes) => {
          return axes.userOptions.className != "highcharts-navigator-yaxis";
        });

        let percent = 10 * allAxis.length;
        percent = 100 - percent.toFixed(2);

        allAxis.forEach((current, currentIdx) => {
          if (currentIdx == 0) {
            current.update(
              {
                top: `0%`,
                height: `${percent + 10}%`,
              },
              false
            );
          } else {
            current.update(
              {
                top: `${percent + currentIdx * 10}%`,
                height: `10%`,
              },
              false
            );
          }
        });
      } else if (indi.needsVolume) {
        indi.params.volumeSeriesID = "vol_" + this.getsymbolList[0].label;
      }

      this.$store.state[`AdvancedChart_${this.mutex}`].chart.addSeries(
        {
          color: indi.color,
          type: name,
          id: indi.event,
          linkedTo: this.getsymbolList[0].label,
          params: indi.params,
          yAxis: indi.isLower ? `a-${name}` : 0,
        },
        true
      );

      let abc = JSON.parse(JSON.stringify(indi));
      this.ActiveIndicators.push(abc);

      indi.isEnabled = true;
    },
    showModal() {
      this.modals.visible = false;
    },
    openSymbolLook(type) {
      this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
      let modalTitle;
      if (type == "compare") {
        modalTitle = "Add Symbol";
      } else {
        modalTitle = "Symbol Lookup";
      }
      this.$store.commit(`AdvancedChart_${this.mutex}/SET_CURRENT_MODAL`, {
        modal: "SymbolLookup",
        modalTitle: modalTitle,
      });

      this.dialog = true;

      this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, true);
    },
    showModal2(item) {
      this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
      if (item.dropdown) {
        item.dropdown.open = !item.dropdown.open;
        return;
      }

      this.$store.commit(`AdvancedChart_${this.mutex}/SET_CURRENT_MODAL`, {
        modal: item.label,
        modalTitle: item.label,
      });

      this.dialog = true;
      this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, true);
    },
    refreshAllSeries(updateType) {
      if (this.$store.state[`AdvancedChart_${this.mutex}`].chart.series.length) {
        for (let index = 0; index < this.$store.state[`AdvancedChart_${this.mutex}`].chart.series.length; index++) {
          const series = this.$store.state[`AdvancedChart_${this.mutex}`].chart.series[index];
          if (
            series.userOptions.id == "main" ||
            series.userOptions.id == "highcharts-navigator-series" ||
            series.userOptions.type == 'flags'

          )
            {
              continue;
              }
          if (series) {
            let chartType = this.options.list[4].dropdown.selected;
            let newData = [];

            if (chartType=='area' && series.userOptions.type != 'column') {
              series.userOptions.ogData.forEach(item => {
                newData.push({
                  x: item.x,
                  y: item.y,
                })
              });
              series.setData([], true);
              series.setData(newData, true);
            }
            else {
              series.setData([], true);
              series.setData(series.userOptions.ogData, true);
            }

            // this.getsymbolDataCache(series.name);
            if (updateType) {
              series.update({}, true);
            } else {
              series.setData({}, true);
            }
          }
        }
        // this.$store.state[`AdvancedChart_${this.mutex}`].chart.redraw();
        // console.log(this.$store.state[`AdvancedChart_${this.mutex}`].chart);
      }
    },
    genIndicatorURL(symbolString, eventType) {
      let URL = `//${this.$store.state.ENV}.quotemedia.com/datatool/getIndicatorsBySymbol.json?`;
      let p = {
        earnings: false,
        splits: false,
        dividends: false,
      };
      p[eventType] = true;
      let uwithParams = Object.keys(p)
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(p[key]);
        })
        .join("&");

      URL += uwithParams;
      return URL + "&symbol=" + symbolString;
    },
    async genChartURL(symbolString) {

      let URL = `//${this.$store.state.ENV}.quotemedia.com/datatool/getEnhancedChartData.json?`;
      let p = this.chartCallParams;
      let uwithParams = Object.keys(p)
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(p[key]);
        })
        .join("&");

      URL += uwithParams;
      return URL + "&symbol=" + symbolString;
      // })
    },
    async getChartData(symbolString) {
      let chartURL = await this.genChartURL(symbolString);
      let cData;

      try {
        const response = await axios.get(chartURL, {
          headers: {
            'Datatool-Token': this.authTOken
        },
        });
        cData = response.data;
      } catch (e) {
        throw e;
      }


      let qData = { OHLCdata: [], volData: [] };
      let adj = this.chartCallParams.unadjusted;

      let dataToUse =
        this.chartCallParams.datatype == "int"
          ? cData.results.intraday[0].interval
          : cData.results.history[0].eoddata;

      let count = dataToUse ? dataToUse.length : 0;

      while (count--) {
        const obj = dataToUse[count];
        let date;
        if (obj.startdatetime) {
          let datesplit = obj.startdatetime.slice(0, 19);
          date = new Date(datesplit).getTime();
        } else {
          date = new Date(obj.date + "T22:22:22").getTime(); //+ "T13:00:00"
        }

        qData.OHLCdata.push({
          x: date,
          vol: obj.sharevolume,
          open: obj.adjustedopen
            ? obj.adjustedopen
            : obj.open
            ? obj.open
            : obj.unadjustedopen
            ? obj.unadjustedopen
            : obj.close,
          high: obj.adjustedhigh
            ? obj.adjustedhigh
            : obj.high
            ? obj.high
            : obj.unadjustedhigh
            ? obj.unadjustedhigh
            : obj.close,
          low: obj.adjustedlow
            ? obj.adjustedlow
            : obj.low
            ? obj.low
            : obj.unadjustedlow
            ? obj.unadjustedlow
            : obj.close,
          close: obj.adjustedclose
            ? obj.adjustedclose
            : obj.close
            ? obj.close
            : obj.unadjustedclose
            ? obj.unadjustedclose
            : 0,
          y: obj.adjustedclose
            ? obj.adjustedclose
            : obj.close
            ? obj.close
            : obj.unadjustedclose
            ? obj.unadjustedclose
            : 0,
        }); //sharevolume

        qData.volData.push([date, obj.sharevolume]);
      }

      return qData;
    },
    async changeScale(nScale, idx) {
        // console.log('ehreereere');
        this.$store.state[`AdvancedChart_${this.mutex}`].chart.showLoading(
        this.$t("labels.loading_dataset") + this.$t("labels." + nScale)
      );

      this.scales.selected = idx;
      if (nScale == "1D") {
        this.frequency.dropdown.selected = '1'
        this.chartCallParams.interval = 1;
      }
      else if (nScale == "5D") {
        this.frequency.dropdown.selected = '15'
        this.chartCallParams.interval = 15;
      }


      this.reloadChart();
    },
    async multiGetData() {
      const getsymbolList = this.getsymbolList;

      let $thisLocal = this;
      await Promise.all(
        getsymbolList.map(async (file, idx) => {
          const chartData = await this.getChartData(file.symbolstring);
          if ($thisLocal.$store.state[`AdvancedChart_${$thisLocal.mutex}`].chart.get(file.symbolstring)) {
              $thisLocal.$store.state[`AdvancedChart_${$thisLocal.mutex}`].chart
              .get(file.symbolstring)
              .update(
                { ogData: chartData.OHLCdata, data: chartData.OHLCdata, name: file.symbolstring },
                false
              );
              $thisLocal.$store.state[`AdvancedChart_${$thisLocal.mutex}`].chart
              .get("vol_" + file.symbolstring)
              .update(
                { ogData: chartData.volData, data: chartData.volData, name: file.symbolstring },
                false
              );
          } else {
            let ops = {};
            let chartType = this.options.list[4].dropdown.selected;


            if (chartType == "ccandlestick") {
              ops = {
                type: "candlestick",
                color: "#F44336",
                upColor: "#4CAF50",
              };
            } else if (chartType == "ohlcc") {
              ops = {
                type: "ohlc",
                color: "#F44336",
                upColor: "#4CAF50",
              };
            } else {
              ops = {
                color: this.seriesColors[idx],
                type: chartType,
                upColor:
                  chartType == "ohlc"
                    ? this.seriesColors[idx]
                    : "#fff",
              };
            }
            // s.update(ops, false);

              this.$store.state[`AdvancedChart_${this.mutex}`].chart.addSeries(
              {
                type: ops.type,
                id: file.symbolstring,
                name: file.symbolstring,
                color: ops.color, //this.seriesColors[idx],
                ogColor: this.seriesColors[idx],
                upColor: ops.upColor,
                data: chartData.OHLCdata,
                ogData: chartData.OHLCdata,
              },
              false
            );

              this.$store.state[`AdvancedChart_${this.mutex}`].chart.addSeries(
              {
                  showInLegend: false,
                // compare: 'percent',
                type: "column",
                id: "vol_" + file.symbolstring,
                name: file.symbolstring, //file.symbolstring,
                yAxis: "vol",
                color: this.seriesColors[idx],
                ogColor: this.seriesColors[idx],
                data: chartData.volData,
                ogData: chartData.volData,
              },
              false
            );
          }
        })
      );

      this.refreshAllSeries(1);

      if (this.scales.selected == 0) {
        let start = new Date();
        start.setHours(-1);

        // this.chart.xAxis[0].setExtremes(start.getTime(), start2);
      } else {
        this.$store.state[`AdvancedChart_${this.mutex}`].chart.zoomOut();
      }
      this.$store.state[`AdvancedChart_${this.mutex}`].chart.redraw();
      this.$store.state[`AdvancedChart_${this.mutex}`].chart.hideLoading();
    },
    async reloadChart() {
      let nScale = this.scales.list[this.scales.selected].value;

      let today = await this.$qModCore.moment();
      if (nScale == "1D") {
        today = today;
        this.chartCallParams.datatype = "int";
        // this.chartCallParams.interval = 1;
      } else if (nScale == "5D") {
        today = today.subtract(1, "week");
        this.chartCallParams.datatype = "int";
        // this.chartCallParams.interval = 15;
      } else if (nScale == "1M") {
        today = today.subtract(1, "month");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "3M") {
        today = today.subtract(3, "month");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "6M") {
        today = today.subtract(6, "month");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "1Y") {
        today = today.subtract(1, "year");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "YTD") {
        today = this.$qModCore.moment().startOf('year');
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "2Y") {
        today = today.subtract(2, "year");
        this.chartCallParams.datatype = "eod";
      }else if (nScale == "3Y") {
        today = today.subtract(3, "year");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "5Y") {
        today = today.subtract(5, "year");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "10Y") {
        today = today.subtract(10, "year");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "20Y") {
        today = today.subtract(20, "year");
        this.chartCallParams.datatype = "eod";
      } else if (nScale == "30Y") {
          today = today.subtract(30, "year");
          this.chartCallParams.datatype = "eod";
      }

      this.chartCallParams.start = today.format("YYYY-MM-DD");
      await this.multiGetData();
    },
    getHeight() {
      // let offset = document.getElementsByClassName("qmodii-modifiers")[0]
      //   .offsetHeight;
      // let offset2 = document.getElementsByClassName(
      //   "qmodii-component-symbolbar"
      // )[0].offsetHeight;

      // let totalOffset = offset + offset2;

      return Math.max(
        400,
        Math.min(
          1000,
          Math.round(
            this.HS.offset(document.getElementById("AdvancedChart"))
              .offsetHeight
          )
        )
      );
    },
    async generateChart() {
      let i8lnInline = (arg1) => {
        return this.$t(arg1);
      };
      let parentCom = this.HS;
      //this.$store.state[`AdvancedChart_${this.mutex}`]

        this.$store.state[`AdvancedChart_${this.mutex}`].chart = await new this.HS.stockChart(
        // document.getElementsByClassName("qmodii-advChart-chart")[0],
            this.$el.getElementsByClassName("qmodii-advChart-chart")[0],
        {
            lang: {
                contextButtonTitle: this.$t("labels.save_chart")
            },
          time: {
            useUTC: false,
          },
          exporting: {
              sourceWidth: 1200,
              sourceHeight: 800,
              enabled: true,
              buttons: {
                  contextButton: {
                      menuItems: [ 'printChart', 'separator', 'downloadPNG', 'downloadSVG', 'downloadPDF'],
                  }
              },
              chartOptions: {
                chart: {
                  backgroundColor: '#fff'
                },
                  plotOptions: {
                      series: {
                        dataLabels: {
                          enabled: false,
                      }
                      },
                      column: {
                          threshold: null,
                      }
                  },
                  rangeSelector: {
                      enabled: false,
                  },
                  legend: {
            symbolPadding: 0,
            symbolWidth: 0,
            symbolHeight: 0,
            squareSymbol: false,
            enabled: true,
            useHTML: true,
              labelFormatter: function() {
                // console.log(this)
                var rvalue = `<span style="color: ${this.userOptions.ogColor}">● </span><span>${this.name} (C: ${this.userOptions.data[this.userOptions.data.length-1].close} / V: ${this.userOptions.data[this.userOptions.data.length-1].vol})</span>`;
                  return  rvalue;
              }
          },
                yAxis: 
                  {
                    title: {
                      text: 'banana'
                    }
                  }
                
              }
          },
          credits: {
              enabled: this.PropCopyright,
              text: '© quotemedia',
              href: 'https://www.quotemedia.com',
              style: {
                  color: '#7d7d7d',
                  fontSize: '11px'
              },
              position: {
                  verticalAlign: 'bottom',
                  align: 'right',
                  y: -2,
                  x: -10
              }
          },
          legend: {
            symbolPadding: 0,
            symbolWidth: 0,
            symbolHeight: 0,
            squareSymbol: false,
            enabled: false,
            useHTML: true,
              labelFormatter: function() {
                // console.log(this)
                var rvalue = `<span style="color: ${this.userOptions.ogColor}">● </span><span>${this.name} (C: ${this.userOptions.data[this.userOptions.data.length-1].close} / V: ${this.userOptions.data[this.userOptions.data.length-1].vol})</span>`;
                  return  rvalue;
              }
          },
          chart: {
              events: {
                  load: function() {
                      parentCom.addEvent(this.tooltip, 'headerFormatter', function(e) {
                          if (!e.isFooter) {
                              //year.getFullYear()
                              //"<div class=\"qmod-hc-tooltip\"><span class=\"qmod-hc-tooltip-date\"></span></div>"
                              // e.text = 'I am a header<br/>';
                              let year = new Date(e.labelConfig.point.x).getFullYear();
                              let replaceString = e.labelConfig.point.key.replace('22:22:22', year);
                              e.text = `<div class=\\"qmod-hc-tooltip\\"><span class=\\"qmod-hc-tooltip-date\\">${replaceString}</span></div>`
                              return false; // prevent default
                          }
                          return true; // run default
                      });
                  }
              },
            backgroundColor: null,
            style: {
              fontFamily: "'Roboto', sans-serif",
            },
            zoomType: "x",
            resetZoomButton: {
              position: {
                align: "right",
                y: 2,
              },
            },
          },
          rangeSelector: {
            enabled: false,
            inputEnabled: false,
          },

          navigator: {
            series: {
              color: this.seriesColors[0],
              lineWidth: 1,
            },
            handles: {
              backgroundColor: this.seriesColors[0],
            },
          },
          scrollbar: {
            barBackgroundColor: this.seriesColors[0],
            barBorderRadius: 7,
            barBorderWidth: 0,
            buttonBackgroundColor: this.seriesColors[0],
            buttonBorderWidth: 0,
            buttonArrowColor: "yellow",
            buttonBorderRadius: 7,
            rifleColor: "yellow",
            trackBackgroundColor: "#fff",
            trackBorderWidth: 1,
            trackBorderColor: this.seriesColors[0],
            trackBorderRadius: 7,
          },

          title: {
            text: null,
          },

          tooltip: {
            backgroundColor: "#fff",
            padding: 5,
            borderWidth: 1,
            borderRadius: 0,
            useHTML: true,
            borderColor: this.seriesColors[0],
            headerFormat:
              '<div class="qmod-hc-tooltip"><span class="qmod-hc-tooltip-date">{point.key}</span></div>',
          },

          plotOptions: {
            series: {
              dataLabels: {
                enabled: false
            },
              turboThreshold: 20000,
              compare: this.options.list[3].dropdown.selected,
              states: {
                inactive: {
                  opacity: 1,
                },
              },
              dataGrouping: {
                enabled: false,
              },
              showInLegend: true,
              lineWidth: 1,
              marker: {
                enabled: false,
              },
            },
            flags: {
              cursor: "pointer",
              tooltip: {
                pointFormat: '<div class="qmod-hc-tooltip">{point.text}</div>',
              },
            },
            line: {
              tooltip: {
                useHTML: true,
                headerFormat:
                  '<div class="qmod-hc-tooltip"><span class="qmod-hc-tooltip-date">{str_replace(point.key,"22:22:22", ""}</span></div>',
                valueDecimals: 2,
                pointFormatter: function () {
                  var HTML = "";
                  HTML +=
                    '<span style="color:' +
                    this.color +
                    '">\u25CF</span> ' +
                    this.series.name +
                    ": ";
                  HTML += "<span>" + this.y.toFixed(2) + " </span>";
                  if (this.change)
                    HTML +=
                      '<span style="color:' +
                      (this.change < 0 ? "red" : "green") +
                      '"> (' +
                      this.change.toFixed(2) +
                      "%) </span>";
                  // return HTML
                  return `
                <div class="qmod-hc-tooltip" style="border-color: ${this.color}">
                  ${HTML}
                </div>
                `;
                  // <div class="qmod-hc-tooltip" style="border-color: ${this.color}">
                  //   <span style="color:${this.color}">\u25CF</span>
                  //   <span class="qmod-hc-tooltip-title"> ${this.series.name}: </span>
                  //   <span class="qmod-hc-tooltip-data">${this.y.toFixed(2)}</span>
                  // </div>
                },
              },
            },
            candlestick: {
              tooltip: {
                useHTML: true,
                pointFormatter: function () {
                  this.color2 = this.open < this.close ? "green" : "red";
                  return `
                <div class="qmod-hc-tooltip">
                  <table class="qmod-hc-tooltip-table">
                    <tr>
                      <td>
                        <span style="color: ${this.color2}">\u25CF </span>
                        <span class="qmod-hc-tooltip-title">${
                          this.series.name
                        }</span>
                      </td>
                      <td>${
                        this.change ? parentCom.numberFormat(this.change) : ""
                      }</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.open"
                      )}:</td><td>${parentCom.numberFormat(this.open)}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.high"
                      )}:</td><td>${parentCom.numberFormat(this.high)}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.low"
                      )}:</td><td>${parentCom.numberFormat(this.low)}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.close"
                      )}:</td><td>${parentCom.numberFormat(this.close)}</td>
                    </tr>
                  </table>
                </div>
                `;
                },
              },
            },
            ohlc: {
              tooltip: {
                useHTML: true,
                pointFormatter: function () {
                  this.color2 = this.open < this.close ? "green" : "red";
                  return `
                <div class="qmod-hc-tooltip">
                  <table class="qmod-hc-tooltip-table">
                    <tr>
                      <td>
                        <span style="color: ${this.color2}">\u25CF </span>
                        <span class="qmod-hc-tooltip-title">${
                          this.series.name
                        }</span>
                      </td>
                      <td>${this.change ? this.change.toFixed(2) : ""}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.open"
                      )}:</td><td>${parentCom.numberFormat(this.open)}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.high"
                      )}:</td><td>${parentCom.numberFormat(this.high)}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.low"
                      )}:</td><td>${parentCom.numberFormat(this.low)}</td>
                    </tr>
                    <tr>
                      <td>${i8lnInline(
                        "labels.close"
                      )}:</td><td>${parentCom.numberFormat(this.close)}</td>
                    </tr>
                  </table>
                </div>
                `;
                },
              },
            },
            column: {
              dataLabels: {
                enabled: false
              }
            }
          },
          xAxis: {
            startOnTick: false,
            endOnTick: false,
            ordinal: true,
            type: "datetime",
          },
          yAxis: [
            {
              id: "main",
              className: "qm-main",
              height: "85%",
              labels: {
                align: "left",
                x: 5,
                formatter: function () {
                  var compare =
                    this.axis.series[0].userOptions.compare || "none";
                  let prefix = compare !== "percent" ? "" : "";
                  let suffix = compare !== "percent" ? "" : "%";
                  let plusminus =
                    compare !== "none" && this.value > 0 ? "+" : "";

                  return `${prefix}${plusminus}${parentCom.numberFormat(
                    this.value
                  )}${suffix}`;
                },
              },
              resize: {
                lineColor: "#666666",
                enabled: true,
                controlledAxis: {
                  next: ["vol"],
                  prev: [""],
                },
              },
            },
            {
              id: "vol",
              className: "qm-vol",
              height: "15%",
              top: "85%",
              labels: {},
              title: {
                useHTML: true,
                text: "Volume",
                align: "high",
                rotation: 0,
                reserveSpace: false,
                y: 15,
                x: 20
              },
            },
          ],
          series: [],
        }
      );
      let items = document.getElementsByClassName('highcharts-menu-item');
      // console.log(items);
    },
  },
  computed: {
    // ...mapGetters(`AdvancedChart_${this.mutex}`, [
    //   "getCurrentModal",
    //   "getsymbolList",
    //   "getModalIsOpen",
    // ]),
    // ...mapState(`AdvancedChart`, ["seriesColors", "ismodalopen"]),

      //$store.state.AdvancedChart_${mutex}.getCurrentModal
      getCurrentModal() {
          return this.$store.state[`AdvancedChart_${this.mutex}`].modals.current;
      },
      getModalIsOpen() {
          return this.$store.state[`AdvancedChart_${this.mutex}`].ismodalopen;
      },
      getsymbolList() {
          return this.$store.state[`AdvancedChart_${this.mutex}`].symbolList;
      },
      seriesColors() {
          return this.$store.state[`AdvancedChart_${this.mutex}`].seriesColors;
      },
      getsymbolDataCache(symbol) {
          return this.$store.state[`AdvancedChart_${this.mutex}`].symbolDataCache[symnol];
      },

    frequency() {
      let selFreq = this.freqs[this.scales.list[this.scales.selected].type];
      return selFreq;
    },
  },
  async mounted() {
    this.authTOken = await this.$qModCore.validateTool(
      "AdvancedChart",
      this.$store.state.WMID,
      this.$store.state.ENV
    );
    let HS = await this.$qModCore.HC();
    this.HS = HS;

    HCDP(HS);
    HCID(HS);
    HCEMA(HS);
    HCTEMA(HS);
    HCBB(HS);
    HCMACD(HS);
    HCRSI(HS);
    HCVWAP(HS);
    ATR(HS);
    CCI(HS);
    MOMENTUM(HS);
    ROC(HS);
    WMA(HS);

    HCPP(HS);
    HCPE(HS);
    HCPSAR(HS);
    HCVBP(HS);
    HCZZ(HS);

    HCDPO(HS);
    HCTRIX(HS);
    WILR(HS);
      exporting(HS);
      offlineexport(HS);

    if (this.PropEnable20Year) {
      this.scales.list.push({
        label: this.$t("labels.20Y"),
        value: "20Y",
        type: "eod",
      });
    }

      if (this.PropEnable30Year) {
          this.scales.list.push({
              label: this.$t("labels.30Y"),
              value: "30Y",
              type: "eod",
          });
      }

    if (this.qmLanguage == "fr") {
      HS.setOptions({
        time: {},
        lang: {
          resetZoom: "Réinitialiser le zoom",
          thousandsSep: " ",
          decimalPoint: ",",
          months: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre",
          ],
          weekdays: [
            "Dimanche",
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi",
          ],
          shortMonths: [
            "Jan",
            "Fév",
            "Mars",
            "Avr",
            "Mai",
            "Jui",
            "Jui",
            "Aoû",
            "Sep",
            "Oct",
            "Nov",
            "Déc",
          ],
        },
      });
    }

    var $bindable = this.$store.state[`AdvancedChart_${this.mutex}`];

    HS.wrap(HS.Axis.prototype, "zoom", function (proceed, newMin, newMax) {
      var ret;

      $bindable.chart.options.rangeSelector.enabled = false;
      $bindable.chart.options.navigator.enabled = false;
      ret = proceed.call(this, newMin, newMax);
      $bindable.chart.options.rangeSelector.enabled = true;
      $bindable.chart.options.navigator.enabled = false;

      return ret;
    });

    let savedSettings = JSON.parse(
      window.localStorage.getItem("qmod_adv_chart")
    );

    this.ogProps["PropChartType"] = this.PropChartType;
    this.ogProps["scalesSelected"] = this.scales.selected;
    this.ogProps["propPriceScale"] = this.options.list[3].dropdown.selected;
    this.ogProps["propAdjustments"] = this.options.list[2].dropdown.selected;
    this.ogProps["propDatatype"] = this.chartCallParams.datatype;
    this.ogProps["freqEod"] = this.freqs.eod.dropdown.selected;
    this.ogProps["freqInt"] = this.freqs.int.dropdown.selected;
    // this.ogProps["PropSymbols"] = this.PropSymbols;
    this.ogProps["PropEvents"] = this.eventsEnabled;

    if (savedSettings) {
      this.PropChartType = savedSettings.type;


      this.options.list[4].dropdown.selected = savedSettings.type;
      this.options.list[3].dropdown.selected = savedSettings.scale;
      this.options.list[2].dropdown.selected = savedSettings.adjusments;
      this.chartCallParams.datatype = savedSettings.datatype;

      this.freqs.eod.dropdown.selected = savedSettings.freqs_eod;
      this.freqs.int.dropdown.selected = savedSettings.freqs_int;

      this.modifyAdjustment();
      this.modifyFrequency();

      // this.PropSymbols = [];
      // savedSettings.symbolist.forEach(element => {
      //   this.PropSymbols.push(element.symbolstring);
      // });

      // this.PropSymbols = this.PropSymbols.join(",");
      this.eventsEnabled = savedSettings["eventsEnabled"];
    }

    let scaleIndex = this.scales.list.findIndex(
      (p) => p.value == this.PropTimeFrame
    );

    this.scales.selected = scaleIndex;

    if (this.PropEnabledEvents != "") {
      this.eventsEnabled = this.PropEnabledEvents.toLowerCase().split(",").map((item) => {
          return item.trim();
        });
    }

    await this.generateChart();

    this.PropSymbols.split(",").forEach(async (element) => {
      await this.addSymbolLookup(element);
    });

    if (savedSettings) {
      this.scales.selected = savedSettings.scales;
    }


    this.eventsEnabled.forEach(async (event) => {
      await this.toggleEvent(event);
    });

    this.$store.metrics.add(this.$options.name, "loaded", this.$props, this.qmWMID);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
$qmblue = #2196f3
$qmgreen = #64bd63
$qmred = #FF0000
.qmodii-advChart-chart
  height 400px
.qmodii-cont
  .qmod-chips
    margin-right 5px
    padding 2px 8px
    border-radius 10px
    background-color $qmblue
    color #fff
  padding 0
  &.qmodii-advanced-chart
    .v-input
      font-size 14px
    .qmodii-component-symbolbar
      display flex
      align-items center
      .qmodii-advChart-savesettings
        margin-left auto
    .qmodii-advChart-series-item
      .qmodii-symbol
        border-bottom 2px solid
      .qmodii-close
        padding-left 5px
      display inline-block
      padding 8px 12px
      cursor pointer
      &:hover
        color #202124
        background-color #f1f3f4
.qmodii-advChart-chart
  .highcharts-data-label
    div
      background-color: #fff
      z-index 99999;
      padding 2px
  .highcharts-scrollbar-thumb
    stroke #fff
  .highcharts-scrollbar-rifles
    stroke #fff
  .highcharts-navigator-mask-inside
    fill rgba(12, 119, 198, 0.3)
  .highcharts-scrollbar-arrow
    fill #fff
  .highcharts-navigator-handle
    stroke #fff
  .highcharts-loading-inner
    color #000
  .highcharts-axis-resizer
    stroke-width 2
  .highcharts-axis.qm-main, .highcharts-axis.qm-vol
    .highcharts-axis-line
      // stroke $qmblue
      // stroke-width: 2
  .highcharts-reset-zoom
    .highcharts-button-box
      fill #fff
      stroke $qmblue
    &.highcharts-button-hover
      text
        color #fff !important
        fill #fff !important
      .highcharts-button-box
        fill $qmblue
  .highcharts-yaxis
    .highcharts-axis-title
      text-transform capitalize
      left 10px !important
      font-size 10px !important
</style>
